import '../../monitoring/filters/grouped_elements/grouped_elements_filter_view.js.coffee'

class Customer.Reports.GroupsFilterView extends Monitoring.Views.SocialContents.Filters.GroupedElementsFilterView
  template: JST["backbone/templates/customer/filters/grouped_elements_filter_modal"]

  selectAll: true
  alias: 'Intelligent Label'
  className: 'tag-filter' # Just to inherit the style

  events: =>
    return _.extend({}, Monitoring.Views.SocialContents.Filters.GroupedElementsFilterView.prototype.events, {
      'click #keywords-close': 'hideModal',
      'click .tags-done': 'onApply',
    })

  initialize: (@options = {}) ->
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false })
    @groups_logic = @getGroupsLogic()
    @possible_elements = @initilizeElements()
    @applied_elements = @initilizeElements()
    @facet_labels = @options.allGroups
    @terms = @facet_labels

  onEditElements: (event) ->
    @$el.find('#edit_elements_modal').addClass('modal')
    super

  getGroupsLogic: ->
    'first_group_elements':    @searchQuery.get(@withPrefix('primary_groups_logic')),
    'second_group_elements':   @searchQuery.get(@withPrefix('secondary_groups_logic')),
    'excluded_group_elements': @searchQuery.get(@withPrefix('excluded_groups_logic'))

  getGroupsElements: ->
    first_group_elements: @withPrefix('primary_labels')
    second_group_elements: @withPrefix('secondary_labels')
    excluded_group_elements: @withPrefix('excluded_labels')

  viewFor: (viewId) =>
    new Monitoring.Views.SocialContents.Filters.LabelsFilterGroupView(@optionsFor(viewId))

  titles: ->
    first_group_elements: 'Main Group'
    second_group_elements: 'Secondary Group'
    excluded_group_elements: 'Excluded Group'

  getValues: ->
    primary_groups: _.pluck(@firstGroupView.appliedElements, 'term'),
    secondary_groups: _.pluck(@secondGroupView.appliedElements, 'term'),
    excluded_groups: _.pluck(@excludedGroupView.appliedElements, 'term'),
    primary_groups_logic: @firstGroupView.logic,
    secondary_groups_logic: @secondGroupView.logic,
    excluded_groups_logic: @excludedGroupView.logic,

  _generateAllElements: (terms)->
    result = []
    result.push({ term: term, description: term.replace(/_/g, ' ')}) for term in terms
    result

  getName: ->
    'labels'

  canFilterOnlyPresent: ->
    false

  hideModal: =>
    @$el.find('#edit_elements_modal').modal('hide')

  onApply: =>
    result = {main_group: {name: 'main_groups'}, secondary_group: {name: 'secondary_groups'}, excluded_group: {name: 'excluded_groups'}}
    result.main_group.logic = @firstGroupView.logic
    result.secondary_group.logic = @secondGroupView.logic
    result.excluded_group.logic = @excludedGroupView.logic

    result.main_group.appliedElements = @firstGroupView.appliedElements
    result.secondary_group.appliedElements = @secondGroupView.appliedElements
    result.excluded_group.appliedElements = @excludedGroupView.appliedElements

    @trigger('selected:groups', result)
    @hideModal()
